module.exports = __webpack_public_path__ + "static/media/iconcoachingcall-copy.cc5ef53c.svg";